<template>
  <div class="hero-visual">
    <div class="soft-rings">
      <div class="ring ring-a"></div>
      <div class="ring ring-b"></div>
      <div class="ring ring-c"></div>
    </div>

    <div class="gradient-mesh">
      <div class="mesh-gradient mesh-1"></div>
      <div class="mesh-gradient mesh-2"></div>
      <div class="mesh-gradient mesh-3"></div>
    </div>
  </div>
</template>

<style scoped>
.hero-visual {
  position: relative;
  width: 100%;
  height: 100%;
  perspective: 1000px;
}

.soft-rings {
  position: absolute;
  inset: 0;
  pointer-events: none;
  -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.96) 0%, rgba(0, 0, 0, 0.78) 48%, rgba(0, 0, 0, 0.22) 64%, transparent 78%);
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.96) 0%, rgba(0, 0, 0, 0.78) 48%, rgba(0, 0, 0, 0.22) 64%, transparent 78%);
}

.ring {
  position: absolute;
  border-radius: 9999px;
  border: 1px solid rgba(99, 102, 241, 0.22);
  background: radial-gradient(circle, rgba(99, 102, 241, 0.08), transparent 65%);
  box-shadow: inset 0 0 30px rgba(99, 102, 241, 0.08), 0 0 40px rgba(56, 189, 248, 0.08);
  animation: ring-float 18s ease-in-out infinite;
}

.ring-a {
  width: 180px;
  height: 180px;
  top: 16%;
  right: 16%;
}

.ring-b {
  width: 130px;
  height: 130px;
  top: 35%;
  right: 6%;
  animation-delay: -6s;
}

.ring-c {
  width: 180px;
  height: 180px;
  top: 52%;
  right: 21%;
  animation-delay: -12s;
}

.dark .ring {
  border-color: rgba(129, 140, 248, 0.35);
  background: radial-gradient(circle, rgba(56, 189, 248, 0.12), transparent 68%);
  box-shadow: inset 0 0 30px rgba(129, 140, 248, 0.14), 0 0 50px rgba(56, 189, 248, 0.14);
  opacity: 0.64;
}

@keyframes ring-float {
  0%, 100% {
    transform: translateY(0) translateX(0) scale(1);
  }
  50% {
    transform: translateY(-18px) translateX(10px) scale(1.04);
  }
}

.gradient-mesh {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}

.mesh-gradient {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  animation: mesh-float 15s ease-in-out infinite;
}

.mesh-1 {
  width: 400px;
  height: 400px;
  background: rgba(139, 92, 246, 0.3);
  top: -100px;
  right: -100px;
  animation-delay: 0s;
}

.mesh-2 {
  width: 300px;
  height: 300px;
  background: rgba(37, 99, 235, 0.25);
  bottom: -50px;
  left: -50px;
  animation-delay: -5s;
}

.mesh-3 {
  width: 350px;
  height: 350px;
  background: rgba(245, 158, 11, 0.15);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation-delay: -10s;
}

@keyframes mesh-float {
  0%, 100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.5;
  }
  33% {
    transform: translate(30px, -30px) scale(1.1);
    opacity: 0.7;
  }
  66% {
    transform: translate(-20px, 20px) scale(0.9);
    opacity: 0.6;
  }
}

@media (max-width: 768px) {
  .ring-a {
    width: 130px;
    height: 130px;
  }

  .ring-b {
    width: 96px;
    height: 96px;
  }

  .ring-c {
    width: 160px;
    height: 160px;
  }
}
</style>
